import { BackgroundCheckColumns, BackgroundCheckData, backgroundCheckEntityName } from '@/backend/features/background-check/shared';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';

export function useBackgroundCheckStorage(): StorageClient<BackgroundCheckData, BackgroundCheckColumns> {
    return useStorageClient<BackgroundCheckData, BackgroundCheckColumns>(backgroundCheckEntityName);
}
